<script>

import {defineComponent} from "vue";
import DashboardBlock from "../../../small_components/DashboardBlock.vue";
import {axiosDashboard} from "../../../../helpers/axios_requests";
import RouterLinkTo from "../../../small_components/RouterLinkTo.vue";
import {ROUTES_NAMES as route_names} from "../../../../router";
import Loader from "../../../small_components/Loader.vue";
import DefaultTitle from "../../../small_components/DefaultTitle.vue";

export default defineComponent({
  computed: {
    route_names() {
      return route_names
    }
  },
  components: {DefaultTitle, Loader, RouterLinkTo, DashboardBlock},
  data() {
    return {
      loading: false,
      ho_o: {},
      urgent: {},
      travel: {},
      benefit: {},
    }
  },
  mounted() {
    this.fetchBlocksData()
  },
  methods: {
    fetchBlocksData() {
      this.loading = true
      axiosDashboard.fetchBlocksData().then(({data}) => {
        this.ho_o = data.ho_o || {}
        this.urgent = data.urgent || {}
        this.travel = data.travel || {}
        this.benefit = data.benefit || {}
      }).finally(() => {
        this.loading = false
      })
    }
  }
})
</script>

<template>
  <div class="row">
    <div class="col-md-3 mt-10">
      <dashboard-block
          :title="$t('articles.urgent')"
          :image="'/images/block/urgent.png'">
        <div class="dashboard-block__body">
          <div class="dashboard-block__href"
               v-for="article in urgent">
            <router-link-to
                v-if="article != null"
                :route_name="route_names.article"
                :route_params="{id: article?.id}">
              {{ article?.title }}
            </router-link-to>
          </div>
        </div>
        <loader v-if="loading"/>
      </dashboard-block>
    </div>
    <div class="col-md-3 mt-10">
      <dashboard-block
          :title="$t('dashboard.blocks.office_activity')"
          :image="'/images/block/ho_o.png'">
        <div class="dashboard-block__body">
            <div class="dashboard-block__body_list"
                v-for="user in ho_o">
              <span>
                {{ user.name + ' ' + user.surname }} -
              </span>
              <span>
                {{ user.report?.working_location ?? $t('dashboard.blocks.colleague_not_filled_report') }}
              </span>
            </div>
        </div>
        <loader v-if="loading"/>
      </dashboard-block>
    </div>
    <div class="col-md-3 mt-10">
      <dashboard-block
          :title="$t('dashboard.blocks.co_worker_vacations')"
          :route="'my_vacation_calendar'"
          :image="'/images/block/travel.png'">
        <div class="dashboard-block__body">
            <div class="dashboard-block__body_list"
                 v-for="user in travel">
              <div v-if="user.vacations.length > 0">
                <span v-for="vacation in user.vacations">
                  {{ user.name + ' ' + user.surname }} - {{ vacation.date_start + ' ' + $t('vacations.to') + ' ' + vacation.date_end }}
                </span>
              </div>
            </div>
        </div>
        <loader v-if="loading"/>
      </dashboard-block>
    </div>
    <div class="col-md-3 mt-10">
      <dashboard-block
          :title="$t('dashboard.blocks.next_benefit')"
          :image="'/images/block/present.png'">
        <div class="dashboard-block__body">
          <default-title h_tag="h5">{{ benefit?.package?.title }}</default-title>
          <default-title h_tag="h6">{{ benefit?.title }}</default-title>
          <span>{{ benefit?.description }}</span>
        </div>
        <loader v-if="loading"/>
      </dashboard-block>
    </div>
  </div>
</template>

<style>

</style>